import {ImageLoaderConfig} from "@angular/common";
import {environment} from "../../../environments/environment";

type ReusableImageLoaderConfig = Pick<ImageLoaderConfig, 'src'> & Partial<Pick<ImageLoaderConfig, 'width'>>;

export function loadMediaUrl(config: ReusableImageLoaderConfig): string {
  if (config.src.indexOf('assets/images/') !== -1) {
    return config.src;
  }

  // can't inject services here, so we need to read persisted token directly
  const tokenCookie = document.cookie.match(/(^|;\s*)token=([^;]*)/);
  const tokenFromCookie = tokenCookie ? decodeURIComponent(tokenCookie[2]) : '';
  const tokenFromLocalStorage = (() => {
    try {
      return localStorage.getItem('hs_token') ?? '';
    } catch {
      return '';
    }
  })();
  const token = tokenFromCookie || tokenFromLocalStorage || undefined;
  const queryPrefix = config.src.includes('?') ? '&' : '?';
  return environment.api.url +
    config.src +
    (token && config.width ?
      queryPrefix + 'width=' + config.width + '&token=' + token :
      token && !config.width ?
        queryPrefix + 'token=' + token :
        !token && config.width ?
          queryPrefix + 'width=' + config.width :
          ''
    );
}
